<!-- <app-customer-header></app-customer-header> -->
<app-corporate-header></app-corporate-header>
<div class="container track-details">
  <form [formGroup]="billingForm" class="truckdetails mt-3">
    <div class="row">
      <div class="col-md-3">
        <p class="d-flex justify-content-center align-items-center" (click)="GoTOBack()">
          <span class="material-icons">arrow_back_ios_new</span> Back
        </p>
        <div class="truck-left">
          <div class="truck-left-icon">
            <img src="assets/img/location-color.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Pickup</h5>
            <p>
              <b>Place:</b>
              {{ searchPickupDetails?.fromLocation?.from_area_name }}
            </p>
            <p>
              <b>Address:</b>
              {{ searchPickupDetails?.fromLocation?.from_area_name }},
              {{ searchPickupDetails?.fromLocation?.from_city_name }},
              {{ searchPickupDetails?.fromLocation?.from_pincode }}
            </p>
          </div>
          <mat-divider></mat-divider>
          <div class="truck-left-icon">
            <img src="assets/img/location-color.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Dropup</h5>
            <p>
              <b>Place:</b>
              {{ SearchTruckDetails?.toLocation?.to_area_name }}
            </p>
            <p>
              <b>Address:</b>
              {{ SearchTruckDetails?.toLocation?.to_area_name }}
              {{ SearchTruckDetails?.toLocation?.to_city_name }}
              {{ SearchTruckDetails?.toLocation?.to_pincode }}
            </p>
          </div>
          <mat-divider></mat-divider>
          <div class="truck-left-icon mt-date">
            <img src="assets/img/date-color.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Date</h5>
            <p>{{ SearchTruckDetails?.date | date : "dd-MM-yyyy" }}</p>
          </div>
          <mat-divider></mat-divider>
          <div class="truck-left-icon mt-date">
            <img src="assets/img/weight.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>DO-Total Tons's</h5>
            <p>{{ coordinatesForm.value.total_tons | number : "1.2-2" }}</p>
          </div>
          <mat-divider></mat-divider>
          <div class="truck-left-icon mt-date">
            <img src="assets/img/weight.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Price Per Ton</h5>
            <p>{{ calculatedPricePerTon }}</p>
            <h5>Total Price</h5>
            <p>{{ calculatedTotalPrice }}</p>
          </div>
          <a (click)="editBookingDetails()">Edit</a>
        </div>
        <div class="truck-left truck-left-category" *ngIf="selecteLoadCategory">
          <div class="truck-left-icon">
            <img src="assets/img/rupee.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Load Category:</h5>
            <p>{{ loadSelectedCategory }}</p>
          </div>
          <div class="truck-left-icon">
            <img src="assets/img/meterial.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5>Material Type:</h5>
            <p>{{ billingForm.value.material }}</p>
          </div>
          <a (click)="editLoadDetails()">Edit</a>
        </div>
      </div>
      <div class="col-md-9">
        <mat-accordion class="truck-details">
          <!-- truck Details list  -->
          <mat-expansion-panel *ngIf="panel" [disabled]="panel" [expanded]="panelForm" hideToggle>
            <mat-expansion-panel-header>
              <img class="width-20" src="../../../assets/img/down.svg" *ngIf="downImg" alt="" />
              <img class="width-20" src="../../../assets/img/checked-color.svg" *ngIf="checkImg" alt="" />
              <mat-panel-title>Booking Details</mat-panel-title>
            </mat-expansion-panel-header>
            <form class="bg-white">
              <div class="row">
                <div class="col-md-5 booking_row">
                  <form [formGroup]="coordinatesForm">
                    <div class="input-fileds-container mt-0">
                      <div class="group mb-0 truck-details-input">
                        <mat-form-field class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                          flex-gt-sm>
                          <mat-icon matPrefix class="me-1 mt-2">near_me</mat-icon>
                          <input formControlName="from_area_name" (change)="onInputPickUpchange($event)"
                            #pickUpLocationSearchField matInput type="text" placeholder="Pickup Area, City" required />
                          <span class="material-icons close-icon" *ngIf="showCloseIconPick"
                            (click)="clearPickField()">close</span>
                        </mat-form-field>
                        <!-- Dynamic Stops -->
                        <div formArrayName="stops" class="stops-wrapper">
                          <div class="stop-field-row" *ngFor="let stop of stopsArray.controls; let i = index"
                            [formGroupName]="i">
                            <div class="stop-input-container">
                              <!-- Stop Address Input -->
                              <mat-form-field
                                class="mat-block pickup_location_09 mat-icon-left flex-gt-md example-full-width"
                                flex-gt-md>
                                <mat-icon matPrefix class="me-1 mt-2">stop_circle</mat-icon>
                                <input matInput placeholder="Add Stop {{ i + 1 }} Area, City" type="text"
                                  formControlName="address" #stopAddress
                                  (focus)="initStopAutocomplete(stopAddress, i)" />
                              </mat-form-field>
                              <!-- Action Buttons -->
                              <div class="stop-actions">
                                <!-- Move Up -->
                                <button type="button" class="btn-icon-sm" (click)="moveStopUp(i)" [disabled]="i === 0"
                                  matTooltip="Move Up">
                                  ↑
                                </button>
                                <!-- Move Down -->
                                <button type="button" class="btn-icon-sm" (click)="moveStopDown(i)"
                                  [disabled]="i === stopsArray.length - 1" matTooltip="Move Down">
                                  ↓
                                </button>
                              </div>
                              <div class="stop-actions">
                                <button type="button" class="btn-delete-sm" (click)="removeStopField(i)"
                                  [disabled]="stopsArray.length === 1" [matTooltipDisabled]="stopsArray.length === 1"
                                  matTooltip="Remove Stop">
                                  ×
                                </button>
                                <button type="button" class="btn-delete-sm" (click)="addStopField()"
                                  matTooltip="Add New Stop">
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <mat-form-field class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                          flex-gt-sm>
                          <mat-icon matPrefix class="me-1 mt-2">location_on</mat-icon>
                          <input (change)="onDropChange($event)" style="color: black; float: right"
                            formControlName="to_area_name" #dropLocationSearchField matInput type="text"
                            placeholder="Dropup Area, City" required />
                          <span class="material-icons close-icon" *ngIf="showCloseIconDrop"
                            (click)="clearDropField()">close</span>
                        </mat-form-field>
                        <mat-form-field class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                          flex-gt-sm>
                          <input matInput [matDatepicker]="picker1" placeholder="Pickup Date" [min]="minDate"
                            [max]="maxDate" formControlName="date" (click)="picker1.open()" required />
                          <mat-datepicker-toggle matSuffix [for]="picker1">
                          </mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field
                          class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width truck-type-input"
                          flex-gt-sm>
                          <mat-select dropLocationSearchField placeholder="Truck Category"
                            formControlName="truck_category_name" (selectionChange)="GetTruckWeight()" required>
                            <mat-option>Select Truck category</mat-option>
                            <mat-option *ngFor="let cat of truckCategory" value="{{ cat._id }}">{{
                              cat.truck_category_name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div class="w-100" style="display: flex; flex-direction: row; justify-content: space-between;">
                          <mat-form-field
                            class="mat-block pickup_location_09 mat-icon-left flex-gt-sm example-full-width"
                            style="width: 48%;" flex-gt-sm>
                            <input #dropLocationSearchField matInput type="text" placeholder="WO - Total Ton's"
                              formControlName="total_tons" required />
                          </mat-form-field>
                          <mat-form-field class="mat-block pickup_location_09 flex-gt-sm truck-type-input"
                            style="width: 48%;" flex-gt-sm>
                            <mat-select placeholder="Price Type" formControlName="price_type" required>
                              <mat-option value="price_per_ton">Price/MT</mat-option>
                              <mat-option value="total_price">Total fare</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <mat-form-field
                          class="mat-block pickup_location_09 mat-icon-left example-full-width"
                          flex-gt-sm
                          *ngIf="coordinatesForm.get('price_type')?.value === 'price_per_ton'">
                          <input matInput type="text" placeholder="Price Per Ton" formControlName="price_per_ton"
                             />
                        </mat-form-field>
                        <mat-form-field
                          class="mat-block pickup_location_09 mat-icon-left example-full-width"
                          flex-gt-sm
                          *ngIf="coordinatesForm.get('price_type')?.value === 'total_price'">
                          <input matInput type="text" placeholder="Total Price" formControlName="total_price"
                             />
                        </mat-form-field>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-7 booking-map-container">
                  <div tabindex="0" aria-label="Map" class="map booking-map" id="map">
                    <google-map width="100%" [center]="inititalCoordinates" [options]="mapConfigurations">
                    </google-map>
                  </div>
                </div>
              </div>
            </form>
          </mat-expansion-panel>

          <!-- load details  -->
          <mat-expansion-panel [disabled]="panel" *ngIf="panel2" [expanded]="panel2form1" hideToggle>
            <mat-expansion-panel-header class="panel2Header">
              <img class="width-20" src="../../../assets/img/down.svg" *ngIf="downImg2" alt="" />
              <img class="width-20" src="../../../assets/img/checked-color.svg" *ngIf="checkImg2" alt="" />
              <mat-panel-title> Load Details </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row panel2 m-0 mt-4">
              <div class="col-sm-2 loadDetails d-flex align-items-center">
                <mat-label>Load Category :</mat-label>
              </div>
              <div class="col-sm-10 d-flex align-items-center load-details-btn-cntr">
                <div class="load-details load-details-btn load-categorie"
                  *ngFor="let item of loadCategory; let i = index">
                  <div [class.load-categorie-selected]="
                      i == loadCategorySelectedindex
                    ">
                    <button (click)="loadCatChange(item.load_category, i)">
                      {{ item.load_category }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row panel2 m-0 mt-4 mb-3">
              <div class="col-sm-2 loadDetails d-flex align-items-center">
                <mat-label>Material Type</mat-label>
              </div>
              <div class="col-sm-10 d-flex align-items-center">
                <div class="load-details">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="material">
                      <mat-option value="">Select Material</mat-option>
                      <mat-option *ngFor="let item of materialDetails?.material_type" (click)="others(item)"
                        value="{{ item.name }}">
                        {{ item.name }} ({{item.hsn_code}})
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row panel2 m-0 mt-4 mb-3" *ngIf="othersType">
              <div class="col-sm-2 d-flex align-items-center">
                <mat-label>Others Material Type</mat-label>
              </div>
              <div class="col-sm-6 d-flex">
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Other Material Type" />
                </mat-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <!-- Billing and payment Details  -->
          <mat-expansion-panel class="panel3" [disabled]="panel2" [expanded]="panel3form1" *ngIf="panel3" hideToggle>
            <mat-expansion-panel-header>
              <img class="width-20" src="../../../assets/img/down.svg" *ngIf="downImg3" alt="" />
              <img class="width-20" src="../../../assets/img/checked-color.svg" *ngIf="checkImg3" alt="" />
              <mat-panel-title>Billing & Payment Details </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row p-4 billing-details">
              <div class="col-md-4" *ngIf="editBilling">
                <p>Billing Details</p>
                <mat-divider class="mat_billing"></mat-divider>
                <div>{{ profileDetails?.username }}</div>
                <div>{{ profileDetails?.address_line }}</div>
                <div>{{ profileDetails?.area_name }}</div>
                <div>
                  {{ profileDetails?.mobile }},{{ profileDetails?.city }}
                </div>
                <div>{{ profileDetails?.pincode }}</div>
                <div>{{ profileDetails?.state }}</div>
                <mat-divider class="mat_billing"></mat-divider>
                <div><strong>GST: {{ profileDetails?.gst }}</strong></div>
                <div class="gst-warning" *ngIf="!isValidGST(profileDetails?.gst)">
                  Invalid GST number -- only <strong>FCM</strong> applicable.
                </div>
                <!-- <div class="gst-mode-container" *ngIf="isValidGST(profileDetails?.gst)">
                  <mat-radio-group
                    aria-label="Select GST Mode"
                    formControlName="gst_mode"
                  >
                    <mat-radio-button value="fcm" class="me-3">FCM</mat-radio-button>
                    <mat-radio-button value="rcm" class="me-3">RCM</mat-radio-button>
                  </mat-radio-group>
                </div> -->
                <div class="Editbtn_billing">
                  <button (click)="BillingEdit()">Edit</button>
                </div>
              </div>
              <div class="col-md-4" *ngIf="billingEdit">
                <p>Billing Details</p>
                <mat-divider class="mat_billing"></mat-divider>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Full Name" formControlName="username" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Address Line 1" formControlName="address_line" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Email" formControlName="email" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="City" formControlName="city" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="State" formControlName="state" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput (keypress)="validateNumber($event)" placeholder="Pincode" formControlName="pincode"
                    maxlength="6" minlength="6" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="GST" formControlName="gst" />
                </mat-form-field>
                <button class="save_btn" (click)="updateBillingAddress()">
                  Save
                </button>
              </div>
              <div class="col-md-4">
                <p>Pickup Details</p>
                <mat-divider class="mat_billing"></mat-divider>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Pickup Name*" formControlName="pickup_name" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput (keypress)="validateNumber($event)" placeholder="Mobile Number*" minlength="10"
                    maxlength="10" formControlName="pickup_contact" />
                </mat-form-field>
                <p class="float-left">DropOff Details</p>
                <mat-divider class="mat_billing"></mat-divider>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput placeholder="Dropup Name*" formControlName="dropoff_name" />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <input matInput (keypress)="validateNumber($event)" placeholder="Mobile Number*" minlength="10"
                    maxlength="10" formControlName="dropoff_contact" />
                </mat-form-field>
                <p class="payment_mode">Payment Mode</p>
                <mat-divider class="mat_billing"></mat-divider>
                <div>
                  <mat-checkbox formControlName="payment_mode" (change)="selectedType($event)">
                    Offline (Credit)
                  </mat-checkbox>
                </div>
              </div>
              <div class="col-md-4">
                <div formArrayName="stop_contacts" *ngIf="stopContactsArray.length > 0">
                  <div>Stop Contact Details</div>
                  <mat-divider class="mat_billing"></mat-divider>
                  <mat-accordion multi="false" class="stops-accordion no-shadow-expansion">
                    <mat-expansion-panel *ngFor="let stop of filteredStopContacts; let i = index" [expanded]="i === 0"
                      [formGroup]="stop">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Stop {{ i + 1 }}: {{ stopsArray.at(i)?.get('city_name')?.value || '' }}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="stop-fields">
                        <mat-form-field appearance="fill" class="example-full-width">
                          <input matInput formControlName="stop_contact_name" placeholder="Contact Name*" />
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="example-full-width">
                          <input matInput maxlength="10" (keypress)="validateNumber($event)"
                            formControlName="stop_contact_number" placeholder="Mobile Number*" />
                        </mat-form-field>
                        <mat-radio-group formControlName="stop_category">
                          <mat-radio-button value="pickup" class="me-3">Pick</mat-radio-button>
                          <mat-radio-button value="dropoff" class="me-3">Drop</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="terms-area" *ngIf="payment_condition">
          <div class="payment_check">
            <p>Payment Will be done as per:</p>
            <mat-radio-group formControlName="pay_as_load_quantity" aria-label="Select an option">
              <mat-radio-button value="1" (change)="selectLoadedQty('loaded_quantity')" class="load_checkbox">Loaded
                Quantity</mat-radio-button>
              <mat-radio-button value="2" (change)="selectLoadedQty('unloaded_quantity')">Unloaded
                Quantity</mat-radio-button>
            </mat-radio-group>
          </div>
          <div>
            <mat-checkbox value="true" required="" formControlName="terms_and_conditions"
              (change)="selectedTerms($event)"><span class="terms-condition">I agree to all the
                <a (click)="getWebPages('termsAndConditions')">terms and condition</a>
              </span>
            </mat-checkbox>
          </div>
          <div>
            <mat-checkbox value="true" required formControlName="insurance_acknowledgement">
              <span>
                I acknowledge that S9 does not provide insurance for goods and arranging insurance is my sole
                responsibility
              </span>
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>
  <button [disabled]="loading" type="button" class="button buttonBlue fixed-btn" *ngIf="TruckDetailsBtn"
    (click)="GoToLoadDetails()">
    <span *ngIf="loading" class="btn-spinner"></span> Next
  </button>
  <button [disabled]="loading" type="button" class="button buttonBlue fixed-btn" *ngIf="loadDetailsBtn"
    (click)="GoToPayments()">
    <span *ngIf="loading" class="btn-spinner"></span> Next
  </button>
  <button [disabled]="loading" type="button" class="button buttonBlue fixed-btn" *ngIf="paymentBtn"
    (click)="tripBooking()">
    <span *ngIf="loading" class="btn-spinner"></span> Submit
  </button>
</div>